import React from "react";
import { Specs } from "../../components/Specs";
import { createReplacer } from "./Replacer";

const wrapSpecs = createReplacer({
  supports({ attribs, name }) {
    return name === "div" && "data-specs" in attribs;
  },
  replace({ children, attribs }) {
    const items = JSON.parse(attribs["data-specs"]);

    const id = children
      .filter((test) => {
        return test.type === "tag" && test.name === "h2";
      })
      // @ts-ignore
      .shift()?.attribs?.id;

    return (
      <>
        <h2 id={id}>Specs</h2>
        <Specs items={items} />
      </>
    );
  },
});

export default wrapSpecs;
